var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProductionBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 19.9999V9.99988C26.2496 9.56147 26.1338 9.13089 25.9144 8.75133C25.695 8.37177 25.3797 8.05658 25 7.83738L16.25 2.83738C15.87 2.61796 15.4388 2.50244 15 2.50244C14.5612 2.50244 14.13 2.61796 13.75 2.83738L5 7.83738C4.62033 8.05658 4.30498 8.37177 4.08558 8.75133C3.86618 9.13089 3.75045 9.56147 3.75 9.99988V19.9999C3.75045 20.4383 3.86618 20.8689 4.08558 21.2484C4.30498 21.628 4.62033 21.9432 5 22.1624L13.75 27.1624C14.13 27.3818 14.5612 27.4973 15 27.4973C15.4388 27.4973 15.87 27.3818 16.25 27.1624L25 22.1624C25.3797 21.9432 25.695 21.628 25.9144 21.2484C26.1338 20.8689 26.2496 20.4383 26.25 19.9999Z",
    stroke: "#0095FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.08752 8.7002L15 15.0127L25.9125 8.7002",
    stroke: "#0095FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 27.6V15",
    stroke: "#0095FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductionBlue);
export default __webpack_public_path__ + "static/media/iconProductionBlue.f4a522569c3bf7b3663222950b7b22dc.svg";
export { ForwardRef as ReactComponent };